import { Mutation } from "@apollo/client/react/components";
import * as palette from "@govlaunch/palette";
import React from "react";
import { FormattedMessage } from "react-intl";
import Switch from "react-switch";
import { useToggle } from "react-use";
import ToggleUsersCanAccessAccountPage from "~/lib/mutations/ToggleUsersCanAccessAccountPage";
import { IToggleUsersCanAccessAccountPageMutation } from "~/lib/mutations/__generated__/ToggleUsersCanAccessAccountPage.generated";
import { IMutationToggleUsersCanAccessAccountPageArgs } from "~/types/types";

interface UsersCanAccessAccountPageProps {
  usersCanAccessAccountPage: boolean;
  vendorId: any;
}

export function UsersCanAccessAccountPageToggleRow({
  usersCanAccessAccountPage,
  vendorId,
}: UsersCanAccessAccountPageProps) {
  return (
    <>
      <div
        css={{
          fontSize: 16,
          fontWeight: 600,
          color: "#949195",
          maxWidth: 200,
        }}
      >
        <FormattedMessage defaultMessage="Enable Users to Access Account Page" id="HpfEcc" />
      </div>

      <div
        css={{
          display: "grid",
          gridColumnGap: 12,
          gridTemplateColumns: "repeat(2, max-content)",
          alignItems: "center",
          color: palette.text,
          fontSize: 16,
          "& > strong": {
            fontWeight: 600,
          },
        }}
      >
        <ToggleUsersCanAccessAccountPageMutation
          usersCanAccessAccountPage={usersCanAccessAccountPage}
          vendorId={vendorId}
        />
      </div>
    </>
  );
}

const ToggleUsersCanAccessAccountPageMutation = ({
  usersCanAccessAccountPage,
  vendorId,
}: UsersCanAccessAccountPageProps) => {
  const [usersAllowedToViewPage, toggleUsersAllowedToViewPage] = useToggle(usersCanAccessAccountPage);

  return (
    <Mutation<IToggleUsersCanAccessAccountPageMutation, IMutationToggleUsersCanAccessAccountPageArgs>
      onCompleted={() => {}}
      variables={{
        vendorId: vendorId,
        isAccessAllowed: usersAllowedToViewPage,
      }}
      mutation={ToggleUsersCanAccessAccountPage}
    >
      {(toggleAccess) => (
        <Switch
          uncheckedIcon={
            <div
              css={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 15,
                color: palette.darkGray,
                paddingRight: 10,
              }}
            >
              off
            </div>
          }
          checkedIcon={
            <div
              css={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 15,
                color: "#fff",
                paddingLeft: 10,
              }}
            >
              on
            </div>
          }
          handleDiameter={22}
          height={26}
          width={65}
          onChange={async (checked) => {
            toggleUsersAllowedToViewPage(checked);
            await toggleAccess({
              variables: {
                vendorId: vendorId,
                isAccessAllowed: checked,
              },
            });
          }}
          checked={usersAllowedToViewPage}
          onColor={palette.greenSuccess}
          offColor={palette.lightGray}
        />
      )}
    </Mutation>
  );
};
